import React from 'react';
import Price from 'atomic/price';
import NumberOfOffer from 'atomic/number-of-offer';
import Carousel from 'components/carousel-multi/carousel-multi';
import Link from 'atomic/link';
import ProductListImpression from 'components/impressions/product-impression/list/product-list-impression';
import { ProductOldInterface } from 'interfaces/product.old.interface';
import Rating from 'atomic/rating';
import { OpinionsItemsInterface } from 'interfaces/opinions.interface';

import './multi-carousel.scss';

interface MultiCarouselProductProps extends Pick<ProductOldInterface, 'id' | 'name' | 'url' | 'price' | 'photos'> {
    offers: {
        count: number;
        items: {
            id: number;
            dealer: {
                id: number;
                name: string;
            };
        }[];
    };
    opinions: {
        url: string;
        count: number;
        average: number;
        items: OpinionsItemsInterface[];
    };
    category: {
        name: string;
    };
    producer: {
        name?: string;
    };
}

export interface MultiCarouselProductsProps {
    count: number;
    items: MultiCarouselProductProps[];
}

interface MultiCarouselProps {
    products: MultiCarouselProductsProps;
    itemsOnDesktop: number;
    itemsOnMobile: number;
    isMobile: boolean;
    isSlideIndicator?: boolean;
}

const MultiCarousel: React.FC<MultiCarouselProps> = ({
    products,
    itemsOnDesktop,
    itemsOnMobile,
    isMobile,
    isSlideIndicator
}) => (
    <Carousel
        swipeable={true}
        draggable={false}
        slideNumberOnDesktop={itemsOnDesktop}
        slideNumberOnMobile={itemsOnMobile}
        renderButtonGroupOutside={true}
        arrows={false}
        isSlideIndicator={isSlideIndicator}
    >
        {
            products.items.map(product => (
                <Link href={product.url} key={product.id} title={product.name}>
                    <div className={`img-container${isMobile ? ' mobile' : ''}`}>
                        <ProductListImpression trackedData={product}>
                            <img
                                src={product.photos.main?.thumb}
                                alt={product.name}
                                loading="lazy"
                            />
                        </ProductListImpression>
                    </div>
                    <div className="title-container">
                        <h3 className="title">
                            {product.name}
                        </h3>
                    </div>
                    <div className="stars-container">
                        <Rating className="sm" opinions={product.opinions} />
                    </div>
                    <div className="price-container">
                        <Price price={product.price} weight={600} />
                    </div>
                    <div className="number-of-offer-container">
                        <NumberOfOffer offers={product.offers} />
                    </div>
                </Link>
            ))
        }
    </Carousel>
);

export default MultiCarousel;
